// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Business_BusinessDesktop__cpSqC {
  width: 60px;
  background-color: #69B4FF;
  transition: width 0.5s ease-in-out;
  cursor: pointer;
}

.Business_tableDesktop__ma1VJ .Business_scrollBar__sZUfN {
  width: calc(50vw - 180px);
  background-color: #69B4FF;
  height: 100vh;
}
.Business_tableDesktop__ma1VJ .Business_content__XdFGM {
  padding: 105px 60px 45px 66px;
  width: calc(50vw - 180px);
}
.Business_tableDesktop__ma1VJ .Business_content__XdFGM .Business_tabTitle__lpj20 {
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 10px;
}
.Business_tableDesktop__ma1VJ .Business_content__XdFGM .Business_title__k-2aN {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  border-bottom: 1px solid #000;
  padding-bottom: 16px;
  margin-top: 70px;
}
.Business_tableDesktop__ma1VJ .Business_content__XdFGM .Business_text__NOPrA {
  padding-top: 22px;
  font-family: "Inter", sans-serif;
  font-size: 20px;
  line-height: 150%;
  color: #140C0F;
}
.Business_tableDesktop__ma1VJ .Business_content__XdFGM .Business_copyright__dARsg {
  margin: 90px 0 30px;
}

.Business_selectedDesktop__CfV9W {
  cursor: default;
  width: calc(50vw - 180px);
}

.Business_BusinessTablet__vyz1e {
  width: 100vw;
  background-color: #69B4FF;
  transition: width 0.5s ease-in-out;
  cursor: pointer;
}

.Business_tableTablet__53vcU .Business_closeIcon__TRLyl {
  position: fixed;
  right: 30px;
  top: 28px;
  z-index: 2;
}
.Business_tableTablet__53vcU .Business_scrollBar__sZUfN {
  background-color: #69B4FF;
  height: 100vh;
}
.Business_tableTablet__53vcU .Business_scrollBar__sZUfN .Business_content__XdFGM {
  padding: 112px 24px 30px 24px;
}
.Business_tableTablet__53vcU .Business_scrollBar__sZUfN .Business_content__XdFGM .Business_tabTitle__lpj20 {
  font-family: "Poppins", sans-serif;
  font-size: 48px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  margin-bottom: 10px;
}
.Business_tableTablet__53vcU .Business_scrollBar__sZUfN .Business_content__XdFGM .Business_title__k-2aN {
  font-family: "Poppins", sans-serif;
  font-size: 32px;
  line-height: 100%;
  color: #140C0F;
  font-weight: 700;
  border-bottom: 1px solid #000;
  padding-bottom: 16px;
  margin-top: 70px;
}
.Business_tableTablet__53vcU .Business_scrollBar__sZUfN .Business_content__XdFGM .Business_text__NOPrA {
  padding-top: 22px;
  font-family: "Inter", sans-serif;
  font-size: 18px;
  line-height: 150%;
  color: #140C0F;
}
.Business_tableTablet__53vcU .Business_scrollBar__sZUfN .Business_content__XdFGM .Business_copyright__dARsg {
  margin-top: 64px;
}

.Business_selectedTablet__FvR-g {
  cursor: default;
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
}`, "",{"version":3,"sources":["webpack://./src/tabs/BusinessDevAndStr/Business.module.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,WCFU;EDGV,yBCOS;EDNT,kCC+Be;ED9Bf,eAAA;AADF;;AAME;EACE,yBAAA;EACA,yBCFO;EDGP,aAAA;AAHJ;AAME;EACE,6BAAA;EACA,yBAAA;AAJJ;AAMI;EC2HF,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;EDtBP,mBAAA;AAAN;AAGI;EC8GF,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;EDjBP,6BAAA;EACA,oBAAA;EACA,gBAAA;AAGN;AAAI;EACE,iBAAA;ECkEJ,gCA3DiB;EA4DjB,eAlDa;EAmDb,iBA3Ce;EA4Cf,cAjGgB;ADkClB;AAHI;EACE,mBAAA;AAKN;;AACA;EACE,eAAA;EACA,yBAAA;AAEF;;AACA;EACE,YAAA;EACA,yBCxCS;EDyCT,kCChBe;EDiBf,eAAA;AAEF;;AAEE;EC5BA,eAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AD8BF;AADE;EACE,yBCnDO;EDoDP,aAAA;AAGJ;AADI;EACE,6BCjDsB;ADoD5B;AADM;EC4EJ,kCAtGkB;EAuGlB,eA1Fa;EA2Fb,iBAtFe;EAuFf,cA7IgB;EA8IhB,gBAvGW;EDyBL,mBAAA;AAOR;AAJM;EC+DJ,kCA9FkB;EA+FlB,eAnFa;EAoFb,iBA9Ee;EA+Ef,cArIgB;EAsIhB,gBA/FW;ED8BL,6BAAA;EACA,oBAAA;EACA,gBAAA;AAUR;AAPM;EACE,iBAAA;ECYN,gCApDiB;EAqDjB,eA5Ca;EA6Cb,iBApCe;EAqCf,cA1FgB;ADwFlB;AATM;EACE,gBAAA;AAWR;;AAJA;ECxEE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;ADgFF","sourcesContent":["@import \"src/styles/variables\";\n\n.BusinessDesktop {\n  width: $tab-width;\n  background-color: $Business;\n  transition: $tab-transition;\n  cursor: pointer;\n\n}\n\n.tableDesktop {\n  .scrollBar {\n    width: calc(50vw - 180px);\n    background-color: $Business;\n    height: 100vh;\n  }\n\n  .content {\n    padding: 105px 60px 45px 66px;\n    width: calc(50vw - 180px);\n\n    .tabTitle {\n      @include font-title-48;\n      margin-bottom: 10px;\n    }\n\n    .title {\n      @include font-title-32;\n      border-bottom: 1px solid #000;\n      padding-bottom: 16px;\n      margin-top: 70px;\n    }\n\n    .text {\n      padding-top: 22px;\n      @include font-20;\n    }\n    .copyright {\n      margin: 90px 0 30px;\n    }\n  }\n}\n\n\n.selectedDesktop {\n  cursor: default;\n  width: calc(50vw - #{$not-active-tabs-width});\n}\n\n.BusinessTablet {\n  width: 100vw;\n  background-color: $Business;\n  transition: $tab-transition;\n  cursor: pointer;\n}\n\n.tableTablet {\n  .closeIcon {\n    @include closeIcon;\n  }\n\n  .scrollBar {\n    background-color: $Business;\n    height: 100vh;\n\n    .content {\n      padding: $mobile-tab-tablet-padding;\n\n      .tabTitle {\n        @include font-title-48;\n        margin-bottom: 10px;\n      }\n\n      .title {\n        @include font-title-32;\n        border-bottom: 1px solid #000;\n        padding-bottom: 16px;\n        margin-top: 70px;\n      }\n\n      .text {\n        padding-top: 22px;\n        @include font-18;\n      }\n\n      .copyright {\n        margin-top: 64px;\n      }\n    }\n  }\n\n}\n\n.selectedTablet {\n  @include selectedTablet;\n}\n\n","//tab sizes\n$tab-width: 60px;\n$not-active-tabs-width: 180px;\n\n//fonts colors\n$title-color: #191114;\n$sub-title-color: #140C0F;\n$footer-color: #323433;\n\n//tabs colors\n$aboutUs: #0085FF;\n$Business: #69B4FF;\n$News: #E0FFFF;\n$Contact: #70E072;\n$MessageSent: #A5F2A6;\n\n//def padding\n$mobile-tab-tablet-padding: 112px 24px 30px 24px;\n\n//def tab content styles\n@mixin selectedTablet {\n  cursor: default;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n}\n@mixin closeIcon {\n  position: fixed;\n  right: 30px;\n  top: 28px;\n  z-index: 2;\n}\n\n//transitions\n$tab-transition: width .5s ease-in-out;\n$left-content-transition-1: opacity .7s ease-in-out;\n$left-content-transition-2: opacity 3s ease-in-out;\n\n//fonts values\n$font-family-main: 'Inter', sans-serif;\n$font-family-title: 'Poppins', sans-serif;\n\n$font-w-400: 400;\n$font-w-700: 700;\n\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-16: 16px; //150%\n$font-size-18: 18px; //150%\n$font-size-20: 20px; // 150%\n$font-size-22: 22px;\n$font-size-24: 24px; //150%\n$font-size-32: 32px; //100%\n$font-size-48: 48px; //80%\n\n$font-size-179: 179px; //80%\n\n$font-line-150p: 150%;\n$font-line-100p: 100%;\n$font-line-80p: 80%;\n\n//font variants\n@mixin font-title-179 {\n  font-family: $font-family-title;\n  font-size: $font-size-179;\n  line-height: $font-line-80p;\n  font-weight: $font-w-700;\n}\n\n@mixin font-13 {\n  font-family: $font-family-main;\n  font-size: $font-size-13;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-14 {\n  font-family: $font-family-main;\n  font-size: $font-size-14;\n  line-height: 16px;\n  color: $sub-title-color;\n}\n\n@mixin font-16 {\n  font-family: $font-family-main;\n  font-size: $font-size-16;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-18 {\n  font-family: $font-family-main;\n  font-size: $font-size-18;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20 {\n  font-family: $font-family-main;\n  font-size: $font-size-20;\n  line-height: $font-line-150p;\n  color: $sub-title-color;\n}\n\n@mixin font-20-title {\n  font-family: $font-family-title;\n  font-size: $font-size-20;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-22 {\n  font-family: $font-family-title;\n  font-size: $font-size-22;\n  line-height: $font-line-80p;\n  color: $sub-title-color;\n}\n\n@mixin font-24 {\n  font-family: $font-family-main;\n  font-size: $font-size-24;\n  line-height: $font-line-150p;\n  color: $title-color;\n  font-weight: $font-w-400;\n}\n\n@mixin font-24-bold {\n  @include font-24;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-32 {\n  font-family: $font-family-title;\n  font-size: $font-size-32;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n\n@mixin font-title-48 {\n  font-family: $font-family-title;\n  font-size: $font-size-48;\n  line-height: $font-line-100p;\n  color: $sub-title-color;\n  font-weight: $font-w-700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"BusinessDesktop": `Business_BusinessDesktop__cpSqC`,
	"tableDesktop": `Business_tableDesktop__ma1VJ`,
	"scrollBar": `Business_scrollBar__sZUfN`,
	"content": `Business_content__XdFGM`,
	"tabTitle": `Business_tabTitle__lpj20`,
	"title": `Business_title__k-2aN`,
	"text": `Business_text__NOPrA`,
	"copyright": `Business_copyright__dARsg`,
	"selectedDesktop": `Business_selectedDesktop__CfV9W`,
	"BusinessTablet": `Business_BusinessTablet__vyz1e`,
	"tableTablet": `Business_tableTablet__53vcU`,
	"closeIcon": `Business_closeIcon__TRLyl`,
	"selectedTablet": `Business_selectedTablet__FvR-g`
};
export default ___CSS_LOADER_EXPORT___;
